import { baseApi } from '@app/store/index.api';

import {
  IChangeTraderTrustLevelQuery,
  IChangeTraderTrustLevelResponse,
  ITraderResponse,
  ITrustLevel,
  ITrustLevelsResponse,
} from '../model/types';

const traderApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTraders: builder.query<ITraderResponse, string>({
      query: query => {
        return {
          url: `pd/traders?${query}`,
        };
      },
    }),
    getTrustLevels: builder.query<ITrustLevelsResponse, void>({
      query: () => {
        return {
          url: 'pd/traders/trust-levels',
        };
      },
      transformResponse: (response: { data: ITrustLevel[] }) => response.data,
    }),
    changeTraderTrustLevel: builder.mutation<
      IChangeTraderTrustLevelResponse,
      IChangeTraderTrustLevelQuery
    >({
      query: ({ id, trust_level_id }) => ({
        url: `/pd/traders/${id}/trust-level`,
        method: 'PATCH',
        body: { trust_level_id },
      }),
    }),
  }),
});

export const {
  useGetTradersQuery,
  useGetTrustLevelsQuery,
  useChangeTraderTrustLevelMutation,
} = traderApi;
